import { swSettings } from "app/common/services/swSettings";
import { isNoTouch, isSI, isTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const shouldShowHDBanner = (): boolean =>
    isNoTouch(swSettings) && !isTrialOrAfterTrial(swSettings) && !isSI(swSettings);
